import Card from './Card'

import { Action, ElementAction } from '../../types'

const LineItemsCard = ({
  lineItems,
  title,
  primaryFooterAction,
  secondaryFooterActions,
  subsectionText,
  timingDetails,
}: {
  lineItems: React.ReactNode
  title: string
  primaryFooterAction?: Action | ElementAction
  secondaryFooterActions?: (Action | ElementAction)[]
  subsectionText?: string[]
  timingDetails?: string
}) => (
  <Card
    title={title}
    primaryFooterAction={primaryFooterAction}
    secondaryFooterActions={secondaryFooterActions}
  >
    {subsectionText && subsectionText.length !== 0 && (
      <Card.Section>
        <div className="text-sm text-gray-700 inline-flex flex-col whitespace-pre-wrap">
          {subsectionText.map((text) => (
            <p key={text}>{text}</p>
          ))}
        </div>
      </Card.Section>
    )}
    <Card.Section>
      {lineItems}
      {timingDetails && (
        <Card.SubSection>
          <h3 className="text-xs font-bold text-gray-900 uppercase tracking-wider">
            Expected shipping/lead time
          </h3>
          <p className="text-sm text-gray-700 whitespace-pre-wrap">{timingDetails}</p>
        </Card.SubSection>
      )}
    </Card.Section>
  </Card>
)

export default LineItemsCard
